<div class="platform-form endpoint-edit-form" qa="prebidSuccess">
  <div *nzModalTitle class="platform-form__top">
    {{data.name}}
  </div>
  <div class="platform-form__middle">
    <div class="success-msg">Endpoint is successfully generated</div>
  </div>
  <div *nzModalFooter class="platform-form__bottom__buttons text-center">
    <button type="button" nz-button nzType="primary" (click)="close()" qa="closePrebidModal">CLOSE</button>
  </div>
</div>
